var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCamera = function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10 6.917a2.5 2.5 0 1 0 2.39 1.764 1.25 1.25 0 1 1-1.654-1.654 2.5 2.5 0 0 0-.736-.11Zm-5.167-3.75.69-1.726c.172-.428.685-.774 1.14-.774h6.674c.459 0 .97.348 1.14.774l.69 1.726h2.332c.921 0 1.668.745 1.668 1.668v9.997c0 .921-.747 1.668-1.668 1.668H2.501c-.921 0-1.668-.745-1.668-1.668V4.835c0-.921.748-1.668 1.668-1.668h2.333ZM2.502 4.833 2.5 14.831l15 .002V4.835l-3.044-.002a.664.664 0 0 1-.573-.385l-.85-2.115H6.962l-.844 2.11a.666.666 0 0 1-.574.39H2.501Zm3.332 4.584a4.167 4.167 0 1 1 8.334 0 4.167 4.167 0 0 1-8.334 0Z"
  })));
};

export default SvgCamera;